/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Docs_Title4Inputs */

const en_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs and listing README`)
};

const ar_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التوثيق وREADME النشر`)
};

const bn_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডক আর লিস্টিং README`)
};

const de_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentation und Listing-README`)
};

const es_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentación y README de publicación`)
};

const fr_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation et README de publication`)
};

const pt_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentação e README de publicação`)
};

const zh_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档和上架 README`)
};

const tr_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgeler ve listeleme README`)
};

const ru_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доки и README для листинга`)
};

const pl_svc_mcp_server_development_docs_title4 = /** @type {(inputs: Svc_Mcp_Server_Development_Docs_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty i README do katalogu`)
};

/**
* | output |
* | --- |
* | "Docs and listing README" |
*
* @param {Svc_Mcp_Server_Development_Docs_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_docs_title4 = /** @type {((inputs?: Svc_Mcp_Server_Development_Docs_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Docs_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "de") return de_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "es") return es_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_docs_title4(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_docs_title4(inputs)
	return en_svc_mcp_server_development_docs_title4(inputs)
});
export { svc_mcp_server_development_docs_title4 as "svc_mcp-server-development_DOCS_title" }